const getValues = (selectedKey = "", options, key) => {
  const dict = {};
  const defaultSelectedKey = !!selectedKey ? selectedKey : "";
  options.forEach((option) => dict[option.key] = option[key]);
  const values = Array.isArray(defaultSelectedKey) ? defaultSelectedKey.map((key2) => dict[key2]) : dict[defaultSelectedKey];
  return values;
};
export {
  getValues
};
//# sourceMappingURL=readOnly.utils.js.map
